'use client'

import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

// FAQ data structure
type FAQItem = {
  question: string
  answer: string
}

type FAQTabData = {
  title: string
  items: FAQItem[]
}

// Define the FAQ data
const faqData: FAQTabData[] = [
  {
    title: 'Photovoltaik',
    items: [
      {
        question: 'Seid ihr die günstigsten bundesweit?',
        answer:
          'Bundesweit kann niemand so günstig Photovoltaikanlagen dauerhaft anbieten. Trotzdem setzen wir auf deutsche Handwerker in allen Gewerken, damit wir eine reibungslose Installation gewährleisten können.',
      },
      {
        question: 'Warum sind eure Lösungen so günstig?',
        answer:
          'Mit 20 Jahren Branchenerfahrungen, wissen wir welche Stellschrauben wichtig sind. Wir vermeiden eine steife und kostenintensive Unternehmensstruktur und arbeiten direkt mit den Herstellern zusammen. Gleichzeitig setzen wir auf deutsche Handwerker, um nicht an Qualität einzubüßen. Dadurch hat GoDeutschland insgesamt wesentlich weniger Kosten und kann flexibler und langfristiger agieren.',
      },
      {
        question: 'Wie sind eure Zahlungsmodalitäten?',
        answer:
          'Wir bieten vier Modelle an:<ul class="list-disc ml-6 mt-2 space-y-1"><li>100% Vorauszahlung = 1,5% Skonto</li><li>40% Nach Auftragsbestätigung, 50% nach Dachmontage-Montage, 10% nach AC-Installation (Elektrik) = 1% Skonto</li><li>0% Anzahlung = 40% nach Lieferung, 50% nach Dachmontage-Montage, 10% nach ACInstallation (Elektrik) = 0% Skonto</li></ul>Miet-Kauf 0% Anzahlung = Sie pachten Ihre Phtovoltaikanlage für 20 Jahre und bezahlten erst mit den monatlichen Zahlungen, wenn Ihre Anlage läuft. Alle Wartungen sind inkludiert. Sie können die Anlage jederzeit direkt kaufen',
      },
      {
        question: 'Wie schnell erfolgt die Installation?',
        answer:
          'Nach Ablauf der zweiwöchigen Widerrufsfrist, liefern wir innerhalb von 1-2 Wochen die Solarmodule und die Unterkonstruktion mit allen Komponenten und Zusatzteilen und fangen mit der Dachmontage an, die in einem Tag erfolgt. Nach ausdrücklicher Zustimmung durch Sie, können wir sofort vor Ablauf der Widerrufsfrist beginnen. Nach erfolgreicher Dachmontage, wird direkt mit der Installation der Wechselrichter und Batteriespeicher begonnen. Innerhalb von 3- 6 Wochen wird die Installation i.d.R. abgeschlossen. Plötzliche Lieferengpässe, Ausfälle durch Krankheit, schlechte Wetterbedingungen und weitere Einfüsse können die Installation natürlich verzögern. Trotz alledem garantieren wir eine schnelle Installation.',
      },
      {
        question: 'Was passiert bei defekten Komponenten und fehlerhafte Installation',
        answer:
          'Unsere Handwerksleistungen haben eine Gewährleistung von 5 Jahren. Wir alle sind Menschen. Sollte es zu Installationsfehlern kommen, werden wir kostenlos und sofort eine Reparatur vornehmen. Das ist für uns selbstverständlich. Bei defekten geleiferten Komponenten, werden ebenfalls sofort und kostenfrei einen Austausch vornehmen. Die einzelnen Komponenten haben eine Produktgarantie.',
      },
      {
        question: 'Garantieleistungen?',
        answer:
          '- Unsere Glas Glas Module = 25 Jahre Produktgarantie auf die Verarbeitung und 30 Jahre Leistungsgarantie.<br>- Deyness Tower Batterie = 10 Jahre Garantie (7 + 3 Jahre nach Registrierung).<br>- Kostal Wechselrichter = 5 – 25 Jahre Garantie (5 Jahre Grundgarantie)<br>- Montage = 5 Jahre Gewährleistung .',
      },
      {
        question: 'Habe ich einen festen Ansprechpartner?',
        answer:
          'Ja. Über unsere eigene App kannst du uns sowieso ständig schreiben oder anrufen. Zudem betreiben wir auch mit einem Partner einen YouTube Kanal. Dort erfährst Du immer neusten Trends und Nachrichten zum Thema Energie.',
      },
      {
        question: 'Wie ist die Qualität der Photovoltaik Komponenten?',
        answer:
          'Wir arbeiten direkt mit den Produzenten zusammen. Daher können wir die Qualität ab Werk gewährleisten und arbeiten ständig mit den Produzenten an Verbesserungen. Gute Technik muss nicht teuer sein. Wir achten darauf, dass jeder sich hochwertige Komponenten leisten kann.',
      },
      {
        question: 'Empfehlungsprogramm?',
        answer:
          'Wenn Sie uns einen Kunden empfehlen, der eine Photovoltaikanlage durch GoDeutschland installieren lässt, erhalten Sie 200 Euro als Prämie ausgezahlt. Bei einer installierten Isolierung, erhalten Sie 300 Euro als Prämie. Insgesamt erhalten Sie also bis zu 500 Euro für jede erfolgreiche Empfehlung. Melden Sie sich an und teilen Sie direkten Ihren individuellen Link mit Freunden und Bekannten: unter www.godeutschland.de/empfehlungsprogramm.',
      },
    ],
  },
  {
    title: 'Isolierung',
    items: [
      {
        question: 'Wie reduziert die Isolierung die Energiekosten?',
        answer:
          'Durch seine diffusionsoffene Struktur ermöglicht ISORYX mit seiner Reflection-Barrier-Technology den Abtransport von Feuchtigkeit aus der Oberfläche und verhindert gleichzeitig durch seine hydrophobe Struktur das Eindringen neuer Feuchtigkeit. Dies führt zu einer trockenen Oberfläche.',
      },
      {
        question: 'Wie wird Schimmel verhindert?',
        answer:
          'Die einweg-diffusionsoffene ISORYX-Beschichtung entzieht der Wand die Feuchtigkeit und verhindert gleichzeitig das Eindringen neuer. Das Resultat: Trockene, schimmel- und algenfreie sowie keimfreie Oberflächen',
      },
      {
        question: 'Wieso wird die Feinstaub-Belastung in Innenräumen geringer?',
        answer:
          'Wird die Isolierung in Innenräumen aufgetragen, entsteht eine gleichmäßige Temperatur im Raum. Dadurch wird eine Thermik verhindert, die Feinstaub verwirbelt. Bei dieser Isolierung bleibt der Feinstaub einfach auf dem Boden liegen.',
      },
      {
        question: 'Mit welchen Kosten muss ich rechnen?',
        answer:
          'GoDeutschland veranschlagt einen Preis zwischen 80 bis 90 Euro pro qm². Dies beinhaltet die Anwendung, Vorbereitungsarbeiten und die Fertigstellung.',
      },
      {
        question: 'Wann amortisiert sich das?',
        answer:
          'Sollte die Isolierung sowohl Innen als auch außen angewendet werden, ist eine Energiekostenreduzierung von 50% möglich, nach kompletter Austrocknung der Beschichtung. Je nach Immobilie amortisiert sich die Isolierung nach wenigen Jahren. Solltest Du z.B. bei einem Einfamilienhaus 5000 Euro Heizkosten pro Jahr haben. Kann sich die Beschichtung nach 6 Jahren amortisieren. Gleichzeitig muss man die Kosten eines Fassaden-Anstrichs hinzurechnen, die in den nächsten 20 Jahren durch die langfristige Sauberkeit der Fassade wegfallen.',
      },
      {
        question: 'Ist die Beschichtung giftig?',
        answer:
          'ISORYX ist nicht brennbar, frei von Giften, kostengünstig und einfach anzuwenden – die ultimative Lösung für alle Gebäudearten und den Denkmalschutz.',
      },
      {
        question: 'Ist der Effekt wissenschaftlich belegt?',
        answer:
          'Ja. Feuchtigkeit im Dämmstoff wirkt wie ein Wärme- und Kälteleiter und reduziert die Dämmleistung drastisch. Bereits ein geringer Anteil von nur 4% Feuchtigkeit im Dämmstoff reduziert die Dämmleistung um ca. 50% (belegt durch Fraunhofer-Institut). Die einweg-diffusionsoffene ISORYX-Beschichtung entzieht der Wand die Feuchtigkeit und verhindert gleichzeitig das Eindringen neuer.',
      },
      {
        question: 'Wie wird die Isolierung angewendet?',
        answer:
          'Die Isolierung wird wie Farbe aufgetragen. Jedoch muss die Anwendung ein zertifzierter Fachbetrieb vornehmen, da einige Schritte beachtet werden müssen, damit sich die Membran korrekt ausprägt und somit die Isolierung die volle Wirkung entfalten kann.',
      },
      {
        question: 'Wo kann die Isolierung aufgetragen werden?',
        answer:
          'Die Beschichtung kann auf Innenwände, Außenwände und in Kühlhäusern aufgetragen werden. Denkmalgeschütze Gebäude sind ebenfalls sehr gut geeignet, sowie mineralische Untergründe, da die Isolierung diffusionsoffen ist.',
      },
      {
        question: 'Garantie Leistungen?',
        answer:
          'Bei Anwendung durch einen zertifzierten Fachbetrieb, wird eine Garantie von 10 Jahren gegeben.',
      },
      {
        question: 'Empfehlungsprogramm?',
        answer:
          'Wenn Sie uns einen Kunden empfehlen, der eine Isolierung durch GoDeutschland installieren lässt, erhalten Sie 300 Euro und Ihre Empfehlung erhält ebenfalls 300 € Rabatt auf die angewendete Leistung.',
      },
    ],
  },
  {
    title: 'Heizsysteme',
    items: [
      {
        question: 'Warum Infrarot?',
        answer:
          'Infrarotheizung gilt als revolutionäre und überlegene Alternative zur konventionellen Konvektionsheizung. Während traditionelle Systeme oft ineffizient sind, erwärmt die Strahlungsheizung direkt die Bausubstanz statt nur die Luft. Trotz mangelnder Berücksichtigung in aktuellen Standards wird sie als die effiziente Zukunft der Heiztechnik angesehen.',
      },
      {
        question: 'Was ist der Vorteil der Strahlungswärme gegenüber der Konvektionswärme?',
        answer:
          'Im Gegensatz zu Konvektionsheizungen erwärmen Infrarotheizungen direkt Objekte im Raum wie Wände und Möbel, nicht hauptsächlich die Luft. Diese Oberflächen nehmen die Wärme auf und geben sie gleichmäßig ab. Das schafft eine sehr behagliche Strahlungswärme, ähnlich wie Sonnenstrahlen. So bleiben Oberflächen warm, was Feuchtigkeit und Schimmelbildung vorbeugt.<br><br>Heizkomfort hängt vom Zusammenspiel von Wand- und Lufttemperatur ab. Bei Konvektion sind Wände oft kühl (ca. 16°C) bei wärmerer Luft (ca. 20°C). Infrarot ermöglicht wärmere Wände (ca. 22°C) bei kühlerer, angenehmerer Luft (ca. 18°C), was das Atmen erleichtert und die Behaglichkeit steigert.',
      },
      {
        question: 'Was ist der Vorteil von Infrarot gegenüber einer Wärmepumpe?',
        answer:
          'Der Vorteil der Infrarotheizung liegt vor allem in den Anschaffungskosten. Diese betragen häufig weniger als 50 % im Vergleich zur Wärmepumpe. Ein weiterer Vorteil liegt in der gleichmäßigen Wärmeverteilung und dem Vermeiden von aufgewirbeltem Staub etc.',
      },
      {
        question: 'Wie fühlt sich Strahlungswärme im Vergleich zu warmer Heizungsluft an?',
        answer:
          'Strahlungswärme empfindet man als besonders behaglich, ähnlich wie das Gefühl in der Sonne oder vor einem warmen Kachelofen zu sitzen. Diese Wärme wirkt direkt auf den Körper und scheint ihn von innen heraus zu durchwärmen, da die Infrarotstrahlung einige Millimeter in die Haut eindringt. Jeder kennt das wohlige Gefühl, wenn die ersten Sonnenstrahlen nach einem kalten Winter den Körper erreichen und oft als belebend empfunden werden.<br><br>In einem strahlungsbeheizten Raum fühlt man sich angenehm warm, auch wenn die Umgebungsluft vergleichsweise kühl ist – was übrigens sehr vorteilhaft für die Atemwege ist. Der hohe Komfort entsteht auch dadurch, dass Oberflächen wie Wände, Decken und Böden wohltemperiert sind und keine Kälte mehr ausstrahlen.',
      },
      {
        question: 'Welchen Unterschied macht Strahlungsheizung beim Lüften?',
        answer:
          'Ein klarer Vorteil der Strahlungsheizung zeigt sich beim Lüften: Da die Wärme hauptsächlich in den Wänden, Böden und Gegenständen gespeichert ist und nicht vorrangig in der Raumluft, bleiben die Wärmeverluste beim Luftaustausch gering. Sie lüften lediglich verbrauchte Luft ab, während die in der Bausubstanz gespeicherte Grundwärme erhalten bleibt. Dies führt zu deutlich weniger Energieverlusten im Vergleich zu Systemen, die primär die Luft erwärmen.',
      },
      {
        question: 'Wie kann Infrarot Schimmel entgegenwirken?',
        answer:
          'Schimmel braucht Feuchtigkeit, um zu existieren. Die Infrarotstrahlung zieht jedoch in die Wände ein, was diese trocken hält. So wird der Nährboden für Schimmel ausgemerzt.',
      },
      {
        question: 'Kann man sich an Infrarotheizungen verbrennen?',
        answer:
          'Obwohl Infrarotheizungen Oberflächentemperaturen von bis zu 105°C erreichen können, besteht bei kurzem oder versehentlichem Kontakt normalerweise keine Verbrennungsgefahr. Die Haut bleibt nicht haften, und ein kurzer Kontakt reicht nicht aus, um Verletzungen zu verursachen. Selbst Haustiere wie Hunde und Katzen legen sich oft darauf und bleiben unverletzt.<br><br>Da Sie die angenehme Strahlungswärme sofort im Raum spüren, ist es ohnehin nicht notwendig, sich sehr nah an der Heizung aufzuhalten.<br><br>Dennoch ist Vorsicht geboten, insbesondere bei kleinen Kindern und Personen mit sensomotorischen Einschränkungen.',
      },
      {
        question: 'Wie werden Infrarotheizungen gesteuert?',
        answer:
          'Infrarotheizungen werden meist über Thermostate geregelt, die die Raumtemperatur erfassen (bei Fußbodenheizungen kann auch die Oberflächentemperatur gemessen werden). Die Heizung läuft mit voller Leistung, bis die Zieltemperatur erreicht ist.<br><br>Die Steuerungsmöglichkeiten reichen von einfachen manuellen Einstellungen über programmierbare Thermostate bis hin zur Integration in Smart-Home-Systeme via Kabel, Funk oder WLAN.<br><br>Es ist sinnvoll, die Heizung zu programmieren, da die ideale Temperatur je nach Raum variiert:<br><br>Generell lässt sich sagen: Jedes Grad Raumtemperatur weniger spart etwa 6% Heizenergie auf der entsprechenden Fläche.',
      },
      {
        question: 'Gibt es Förderungen oder ähnliches?',
        answer:
          'Zum 01.01.2020 trat folgende Vorschrift des § 35c EStG in Kraft:<br><br>Energetische Sanierungsmaßnahmen an zu eigenen Wohnzwecken genutzten Gebäuden mittels progressionsunabhängigen Steuerabzugs werden steuerlich gefördert. Die Steuerermäßigung beträgt insgesamt 20 % der angefallenen, begünstigten Aufwendungen (max. 40.000 Euro). Abzugsfähig sind dabei:<br><br>- 7 % der Aufwendungen (max. jeweils 14.000 Euro) im Jahr des Abschlusses der Maßnahme und im ersten darauffolgenden Kalenderjahr sowie<br>- 6 % der Aufwendungen (max. 12.000 Euro) im zweiten darauffolgenden Kalenderjahr.<br><br>Geförderte Maßnahmen:<br><br>- Wärmedämmung<br>- Austausch von Fenstern<br>- neue Heizung<br><br>Diese Angabe hat keinen Anspruch auf Aktualität.<br><br>Außerdem ist es möglich eine BZA bei der KFW zu stellen da Infrarotheizungen unter Heizungserneuerungen nicht ausgeschlossen werden.',
      },
      {
        question: 'Gibt es bei Infrarotheizungen laufende Kosten?',
        answer:
          'Bei Infrarotheizungen fallen kaum Neben- oder Wartungskosten an. Da das System nahezu verschleißfrei ist, sind regelmäßige Wartungen oder der Austausch von Teilen, wie bei anderen Heizsystemen üblich, nicht nötig. Lediglich die Batterien kabelloser Thermostate müssen gegebenenfalls ersetzt werden; durch die Verwendung von Akkus lassen sich selbst diese geringen Ausgaben umgehen.',
      },
      {
        question: 'Muss eine Infrarotheizung gewartet werden?',
        answer:
          'Nein, Infrarotheizungen sind konstruktionsbedingt vollständig wartungsfrei. Da es weder Verschleiß noch Korrosion gibt, entfallen regelmäßige Wartungsarbeiten komplett.<br><br>Lediglich bei kabellosen Thermostaten (ohne direkte Stromversorgung) müssen gelegentlich die Batterien ersetzt werden. Nutzen Sie dafür Akkus, sparen Sie Abfall und langfristig Kosten.',
      },
      {
        question: 'Was sind die Vorteile von Infrarotheizungen?',
        answer:
          'Infrarotheizungen sind energieeffizient, wartungsarm und sorgen für eine angenehme, gleichmäßige Wärme. Sie eignen sich ideal für Wohnräume, Büros und sogar für Außenbereiche.',
      },
      {
        question: 'Wer installiert die Infrarotheizungen?',
        answer:
          'Die Installation der Infrarotheizungen wird von unserem Partner, der Infrastar GmbH, übernommen. Sie sind Experten auf diesem Gebiet und bieten maßgeschneiderte Lösungen. Die Infrastar GmbH hat das weltgrößte Sortiment an Infrarotheizsystemen.',
      },
      {
        question: 'Kann ich eine Infrarotheizung auch in einem Altbau installieren?',
        answer:
          'Ja, Infrarotheizungen können sowohl in Neubauten als auch in Altbauten problemlos installiert werden. Wir beraten Dich gerne zu den Möglichkeiten in deinem Gebäude.',
      },
      {
        question: 'Wie viel kostet eine Infrarotheizung?',
        answer:
          'Die Kosten hängen von der Größe und Leistung der Heizung ab. Ein Angebot kannst Du direkt von uns erhalten. Die infrastar GmbH hat das weltgrößte Infrarotheizungssortiment. Von einer einfachen Infrarotplatte bis zu einer Designfolie mit Lichtintegration oder einem Bilderrahmen mit integrierter Infrarotheizung, kann so gut wie jede Anforderung erfüllt werden.',
      },
    ],
  },
]

// Accordion Item Component
const AccordionItem = ({
  question,
  answer,
  isOpen,
  onClick,
}: {
  question: string
  answer: string
  isOpen: boolean
  onClick: () => void
}) => {
  return (
    <div className="mb-4 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm transition-all duration-300 dark:border-gray-700 dark:bg-gray-800/40">
      <button
        className="flex w-full cursor-pointer items-center justify-between px-6 py-5 text-left text-base font-medium text-gray-900 transition-colors hover:bg-gray-50 dark:text-white dark:hover:bg-gray-800/70"
        onClick={onClick}
      >
        <span className="text-lg">{question}</span>
        <motion.span
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          className="ml-4 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-orange-100 text-[#ff4500] dark:bg-orange-900/30 dark:text-orange-400"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <div
              className="px-6 pt-0 pb-5 text-base text-gray-700 dark:text-gray-300"
              dangerouslySetInnerHTML={{ __html: answer }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

// Main FAQ Section Component
export default function FAQSection() {
  const [activeTab, setActiveTab] = useState(0)
  const [openAccordionIndex, setOpenAccordionIndex] = useState<number | null>(null)

  // Intersection observer for section entry animation
  const [sectionRef, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1,
  })

  // Reset open accordion when changing tabs
  useEffect(() => {
    setOpenAccordionIndex(null)
  }, [activeTab])

  // Handle accordion toggle
  const toggleAccordion = (index: number) => {
    setOpenAccordionIndex(openAccordionIndex === index ? null : index)
  }

  return (
    <section ref={sectionRef} className="relative mb-16 py-24">
      {/* Removing decorative gradient elements */}
      {/* <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute -right-24 -bottom-24 h-64 w-64 rounded-full bg-orange-100 opacity-50 blur-3xl dark:bg-orange-900/20"></div>
        <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full bg-orange-100 opacity-50 blur-3xl dark:bg-orange-900/20"></div>
      </div> */}

      <div className="mx-auto max-w-7xl md:px-0">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
          className="mb-16 text-center"
        >
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mb-2 inline-block text-lg font-medium text-orange-500"
          >
            <span className="inline-block rounded-full bg-orange-100 px-3 py-1 text-[#ff4500] dark:bg-orange-900/30 dark:text-orange-400">
              Häufig gestellte Fragen
            </span>
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="mb-6 text-3xl font-bold sm:text-4xl lg:text-5xl"
          >
            Antworten auf häufige Fragen?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="mx-auto max-w-3xl text-lg text-gray-600 dark:text-gray-300"
          >
            Hier finden Sie Antworten auf die häufigsten Fragen zu unseren Energielösungen
          </motion.p>
        </motion.div>

        {/* Tabs */}
        <div className="mb-10">
          <div className="mb-8 flex flex-wrap justify-center gap-2 sm:gap-4">
            {faqData.map((tab, index) => (
              <motion.button
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.5, delay: 0.1 + index * 0.1 }}
                onClick={() => setActiveTab(index)}
                className={`relative cursor-pointer overflow-hidden rounded-lg px-6 py-3 text-base font-medium transition-all duration-300 ${
                  activeTab === index
                    ? 'bg-[#ff4500] text-white shadow-lg'
                    : 'bg-white text-gray-700 shadow-sm hover:bg-orange-100 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700'
                }`}
              >
                {tab.title}
                {activeTab === index && (
                  <motion.div
                    layoutId="activeTabIndicator"
                    className="absolute inset-0 -z-10 rounded-lg bg-[#ff4500]/20"
                    initial={false}
                    transition={{ type: 'spring', stiffness: 300, damping: 30 }}
                  />
                )}
              </motion.button>
            ))}
          </div>

          {/* Accordion Items */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
              className="relative"
            >
              {faqData[activeTab].items.map((item, index) => (
                <AccordionItem
                  key={index}
                  question={item.question}
                  answer={item.answer}
                  isOpen={openAccordionIndex === index}
                  onClick={() => toggleAccordion(index)}
                />
              ))}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  )
}
